import { localeSpecificGroup } from '../../../utils/override';
import { staticText } from '../../../utils/translations/staticText';

const translations = staticText({
  login: { _: 'Log in', zh: '登入' },
  logout: { _: 'Logout', zh: '登出' },
  // Header language toggle (CMS-2008), keyed by the locale of the page the visitor is on: the label
  // names the other language in that language, the hint read out after it is in the page's own.
  languageToggleLabel: { _: '中文', zh: 'English' },
  languageToggleHint: { _: 'Switch to Chinese', zh: '切換至英文' },
});

export const NAVIGATION_TRANSLATIONS = localeSpecificGroup(translations);
